export default "__VITE_ASSET__3ba5bd72__"